<template>
  <transition name="fade">
    <footer v-if="show && !loading">
      <div class="container">
        <LinkInstagram :pseudo="instagram.userInstagramPseudo" :name="instagram.userInstagramName"/>
        <router-link class="link" to="/legal-mention">Legal Mention</router-link>
        <p class="link">Made with <span class="heart">❤</span> by <a target="_blank" href="https://www.linkedin.com/in/huu-tai-le-b873b1109/" title="Tai LÊ">Tai</a></p>
      </div>
    </footer>
  </transition>
</template>

<script>
import { FOOTER } from '../queries'
import { useQuery, useResult } from '@vue/apollo-composable'
import { useShowTimeout } from '../compositions/useShowTimeout'

import LinkInstagram from '../components/LinkInstagram'

export default {
  name: 'Footer',
  components: {
    LinkInstagram
  },
  setup() {
    const show = useShowTimeout(1000)

    const { result, loading } = useQuery(FOOTER)
    const instagram = useResult(result, null, data => data.siteGeneralSettings.instagram)

    return {
      show,
      loading,
      instagram
    }
  }
}
</script>

<style lang="scss" scoped>
  footer {
    position: relative;
    margin: 4rem 0 1rem;
    z-index: 10;
  }

  .container {
    @extend %container;

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media screen and (max-width: $mobile){
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
  }

  .link {
    @extend %font-regular;

    font-size: 0.4rem;
    letter-spacing: 0.2rem;
    margin-top: 0.5rem;
    line-height: 1.2rem;

    .heart {
      color: $red;
    }
  }

</style>